export default __webpack_public_path__ + "static/media/Keep moving.6a4aec96.png";